import { type Action, TrackObject, useAnalyticsTracker } from ".";
import type { BaseAnalyticsExtras } from ".";

export interface CarouselExtras extends BaseAnalyticsExtras {
  slideId: string;
  slideTitle?: string;
  ctaText?: string;
  route?: string;
  slideIndex: number;
  control: string;
  controlType: string;
}

export type CarouselEvent = {
  action: Action.PRESSED;
  extras: CarouselExtras;
};

export const useCarouselAnalytics = () =>
  useAnalyticsTracker<CarouselEvent>(TrackObject.CAROUSEL);
